import { useContext } from 'react';
import MobileFormContext from '../../../../components/mobileForm/context/mobileFormContext';

export function useAttachmentsComponent({ idInput, parents }) {
  const { getAttachmentsSignedPost } = useContext(MobileFormContext);

  const uploadAttachment = async (file) => {
    return getAttachmentsSignedPost({
      file,
      idInput,
      parents,
    });
  };

  return { uploadAttachment };
}
